import React, { useEffect, useState } from 'react';
import "./style.sass";
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';
import { InformacionPersonalDesktop } from './informacionPersonalDesktop';
import { InformacionPersonalParte2 } from './informacionPersonalParte2';
import { InformacionEmpleoDesktop } from './InformacionEmpleoDesktop';
import { InformacionFinancieraDesktop } from './InformacionFinancieraDesktop';
import { SolicitudFinalizadaDesktop } from './solicitudFinalizadaDesktop';
import { removeStorage } from 'functions/storageBase64';
import { Error500 } from 'components/Error/Error500'

export function SolicitarTarjetaDesktop() {

    const history = useHistory();
    const [pasoSolicitud, setPasoSolicitud] = useState(1);
    const [numFolio, setNumFolio] = useState(false);
    const [nombreTarjeta, setNombreTarjeta] = useState(false);

    const fijarPasoActual = (paso) => {
        setPasoSolicitud(paso);
    }

    const cancelar = () => {
        if (pasoSolicitud === 1) {
            history.goBack(-1);
        }
        else {
            setPasoSolicitud(1);
        }
    }

    const [errorCode, setErrorCode] = useState()

    useEffect(() => {
        removeStorage('infoPersonalStorage');
        removeStorage('infoPersonal2Storage');
        removeStorage('infoTrabajoStorage');
        removeStorage('infoFinancieraStorage');
    }, [])

    return (
        <>
            <Header type="complete" />

            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />
                    {errorCode >= 500
                        ?
                        <Error500 />
                        :
                        <div className="contenidoSolicitarTarjeta">
                            <div className="divTitulo">
                                <p>Solicitud de Crédito Claroshop</p>
                            </div>

                            {pasoSolicitud === 1 && <InformacionPersonalDesktop nextPage={fijarPasoActual} cancelar={cancelar} />}

                            {/* {pasoSolicitud === 1 && <InformacionPersonalParte2 nextPage={fijarPasoActual} cancelar={cancelar} />} */}

                            {pasoSolicitud === 2 && <InformacionEmpleoDesktop nextPage={fijarPasoActual} cancelar={cancelar} />}

                            {pasoSolicitud === 3 && <InformacionFinancieraDesktop nextPage={fijarPasoActual} cancelar={cancelar} setNumFolio={setNumFolio} setNombreTarjeta={setNombreTarjeta} setErrorC={setErrorCode} />}

                            {pasoSolicitud === 4 && <SolicitudFinalizadaDesktop numFolio={numFolio} nombreTarjeta={nombreTarjeta} />}

                        </div>
                    }
                </section>
            </main>

            <Footer type="complete" />
        </>
    )
}